// extracted by mini-css-extract-plugin
export default {"goalsTable":"styles_goalsTable__aA8fn"};